module.exports = __webpack_public_path__ + "static/media/hiw4.193468a6.svg";